<template>
  <!-- <div id="container" ref="mapRef" class="mainBox"> -->
    <div id="container" class="mainBox">
      <!-- <iframe  id="iframeContain"  name="iframeContain"  seamless  scrolling="yes"  src="http://lcdata.laicun.wang/bd/3dmap" ></iframe>
 -->
      <iframe src="3dmap" style="width:100%;height:100%;border: none;"></iframe>
       <!--顶部  -->
      <div class="topContent">
        <div class="dh_wz">
          <div class="dh_wz_qq"> </div>
          <div class="dh_wz_tb"></div>
          <div class="dh_wz_wz">高标准农田</div>
        </div>
        <div class="dh_lb">
          <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt">项目总览</div></router-link>
          <router-link :to="{path:'/plant'}"><div class="dh_lb_bt">高标准农田</div></router-link>
           <!-- <router-link :to="{path:'/gbzntjs'}"><div class="dh_lb_bt">项目进度</div></router-link> -->
          <router-link :to="{path:'/zhinengGG'}"><div class="dh_lb_bt dh_lb_bt_cur">智能灌溉</div></router-link>
          <router-link :to="{path:'/binghai'}"><div class="dh_lb_bt">病虫害管理</div></router-link>
          <!-- <router-link :to="{path:'/plantmoxing'}"><div class="dh_lb_bt">种植模型</div></router-link> -->
          <!-- <router-link :to="{path:'/suyuan'}"><div class="dh_lb_bt">农业溯源</div></router-link> -->
          <!-- <router-link :to="{path:'/qihouYj'}"><div class="dh_lb_bt">气候灾害预警</div></router-link> -->
        </div>
        <div class="titleRightImg">
          <router-link :to="{ path: '/' }"><img src="../assets/img/gbzntyj/sy.png" class="return" /></router-link>
          <img  src="../assets/img/gbzntyj/fh.png"  class="return"  @click="clickReturn"  />
        </div>
      </div>
        <!-- z左侧 -->
        <div class="left">
          <div class="leftBox1">
            <div class="title">数据中心<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="leftBox1Content">
              <div class="leftBox1ContentTop">
                <div class="circle"></div>
                <img src="../assets/img/gbzntyj/gaungai/gg.png" class="circleImg" />
                <div class="leftBox1ContentTopList" v-if="showDiv">
                  <div v-for="(item,index) in leftData1A" :key="index" class="leftBox1ContentTopItem  animate__animated" :class="index==0||index==2 ? 'animate__fadeInLeft' : 'animate__fadeInRight'">
                        <div class="contentLine contentLine1"></div>
                        <div class="contentLine contentLine2"></div>
                        <div class="contentLine contentLine3"></div>
                        <div class="contentLine contentLine4"></div>
                        <span class="txt1">{{item.name}}</span><span class="txt2">{{item.value}}{{item.unit}}</span>
                  </div> 
                </div>
              </div>
              <div class="leftBox1ContentCenter">
                <div class="dateItem" :class="{dateItemCur:left1Cur==index}" v-for="(item,index) in leftData1Date" :key="index" @click="tabDate(dateItemCur)">{{item}}</div>
              </div>
              <div class="leftBox1ContentBottom">
                <div class="leftBox1ContentBottom1 animate__animated animate__fadeInLeft"  v-if="showDiv">
                  <div class="leftBox1ContentBottomItem" v-for="(item,index) in leftData1B" :key="index">
                  <div class="leftItem"><img :src="item.icon" /></div>
                  <div class="rightCon"><span class="txt1">{{item.value}}</span><span class="txt2">{{item.name}}</span></div>
                </div>
              </div>
                
              </div>
            </div>
          </div>
          <div class="leftBox2">
            <div class="title">水肥变化量<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="echartBox" ><LeftBar /></div>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="right">
          <div class="rightBox1" id="video1">
            <div class="title">视频监控<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="videoBox">
              <div class="videoBg">
                <div class="contentLine contentLine1"></div>
                <div class="contentLine contentLine2"></div>
                <div class="contentLine contentLine3"></div>
                <div class="contentLine contentLine4"></div>
                <vue3VideoPlay id="video"
              ref="videoRef"
              width="100%"
              height="100%"
              title="视频监控"
              :src="options.src"
              :type="options.type"
              :autoPlay="true"
              :muted="true"
              :control="false"
              @loadedmetadata="onLoadedMetadata"
            />
              </div>
              <div class="videoTabList"><div class="videoTabItem" v-for="(item,index) in tabList" :key="index">{{item}}</div></div>
            </div>
            <div class="videoBox">
              <div class="videoBg">
                <div class="contentLine contentLine1"></div>
                <div class="contentLine contentLine2"></div>
                <div class="contentLine contentLine3"></div>
                <div class="contentLine contentLine4"></div>
                <vue3VideoPlay  width="100%"  height="100%"  title="视频监控"  :src="options1.src"  
                :type="options.type"  :autoPlay="true" :control="false" />
              </div>
              <div class="videoTabList"><div class="videoTabItem" v-for="(item,index) in tabList" :key="index">{{item}}</div></div>
            </div>
          </div>
          <div class="rightBox2">
            <div class="title">灌溉水量<img src="../assets/img/gbzntyj/gaungai/fk.png" class="titIcon" /></div>
            <div class="echartBox"><rightLine /></div>
          </div>
        </div>

  </div>
  <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
  watch
} from "vue";

// todo 项目使用请放开 leaflet 引入
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// // import * as L from 'leaflet/dist/leaflet.esm.js';
// import Gep from "../utils/范围面.json";
// import ldt from "../components/gbzntyj/ldt.vue";
// import dczz from "../components/gbzntyj/dczz.vue";
import LeftBar from "../components/ZhinengGG/LeftBar"
import rightLine from "../components/ZhinengGG/rightLine"
import footer1 from "../components/footer.vue";

export default {
  name: "Home",
  setup() {
    let statusUpdateInterval;
    // const timer = ref(null);
    const router = useRouter();
    const videoRef = ref(null);
    const state = reactive({
      leftData1A:[{name:"总流量",value:"0.01",unit:"m³/h"},{name:"运行速度",value:"45.0",unit:"m/h"},{name:"水渠液位",value:"0.3",unit:"m"},{name:"运行时间",value:"0.3",unit:"h"}],
      leftData1Date:["3.01","3.02","3.03","3.04","3.05","3.06","3.07"],
      left1Cur:0,
      leftData1B:[{name:"灌溉水量",value:"0.00",unit:"m³",icon:require('@/assets/img/gbzntyj/gaungai/sl.png')},{name:"灌溉亩数",value:"0.00",unit:"亩",icon:require('@/assets/img/gbzntyj/gaungai/ms.png')},{name:"亩均灌溉量",value:"0.00",unit:"m³/亩",icon:require('@/assets/img/gbzntyj/gaungai/pj.png')}],
      showDiv:true,
      tabList:["固定喷灌","指针喷灌","平移喷灌","水肥一体机"],
      options: {
        src: require("@/assets/video/zzng.mp4"), //视频源
        type: "video/mp4", //视频类型
        },
      options1: {
        src: require("@/assets/video/gg.mp4"), //视频源
        type: "video/mp4", //视频类型
        },
        status:1,
        currentTime1:0,
        laststatus:0
    });





    // 在 onMounted 中初始化地图
    // onMounted(() => {
    //   setInterval(() => {
    //     axios
    //       .post("https://smartfarm.laicunwang.com/api/index/datagg", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
    //       .then((res) => {
    //         console.log(res.data.data.status)
    //         let status = res.data.data.status
    //         state.status=status
    //         if(status==1){
    //           // state.options.src=require("@/assets/video/zzng1.mp4")
    //           // state.status=1
    //           console.log("播放")
    //           // state.currentTime1 = 6
    //           videoRef.value.play();
    //         }else{
    //           // state.options.src=require("@/assets/video/zzng2.mp4")
    //           // state.freed_time=0
    //           // state.currentTime1 = 0
    //           videoRef.value.pause();
    //         }
    //       })
    //   }, 5000);
    // });
    // 
     onMounted(() => {
      statusUpdateInterval = setInterval(async () => {
        const res = await axios.post(
          "https://smartfarm.laicunwang.com/api/index/datagg",
          {
            sign: "c4c6cff9b7ec6b87fa953f77ec7e624b",
          }
        );

        state.laststatus = res.data.data.status;
        // state.laststatus += 1;
        console.log(state.laststatus);
      }, 3000);
    });
       function handleVideoStatusChange(newLastStatus) {
      if (videoRef.value) {
        if (newLastStatus == 1) {
          videoRef.value.play(); // 当 laststatus 变为 1 时开始播放
        } else if (newLastStatus == 2) {
          videoRef.value.pause(); // 当 laststatus 变为 2 时暂停播放
        }
      }
    }
     function onLoadedMetadata() {
      state.options.autoPlay = false;
      videoRef.value.pause(); // 在元数据加载完成后立即暂停视频

      watch(
        () => state.laststatus,
        (newLastStatus, oldLastStatus) => {
          console.log(
            "laststatus 变化了：",
            newLastStatus,
            "（旧值：",
            oldLastStatus,
            "）"
          );
          handleVideoStatusChange(newLastStatus);
        },
        { immediate: true }
      );
    }
    // function videoErrorCallback(e){
    //   console.log(e)
    // }
    // function videoTimeUpdateEvent(e) { // 播放进度改变
    //   // console.log(e.target.currentTime)
		// 	// 	// e.detail.currentTime为每次触发时,视频的当前播放时间
		// 	// 	let currentTime = Number(e.target.currentTime);
		// 	// 	if (currentTime >= 11 && state.status==1) {
         
          
    //   //     videoRef.value.pause();
          
		// 	// 	}
		// }
    function onPlayerReady(){
      console.log("kk")
    }
    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function tabDate(index){
      this.showDiv = false; // 点击后先隐藏div
      this.left1Cur = index
      setTimeout(() => {
        this.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }
    
    onUnmounted(() => {
      clearInterval(statusUpdateInterval);
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      videoRef,
      clickReturn,
      tabDate,
      onPlayerReady,
      handleVideoStatusChange,
      onLoadedMetadata
    };
  },
  components: {
    LeftBar,
    rightLine,
    footer1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
  font-size: 14px;
  overflow: hidden;
}
#echartBox{
  font-size: 14px;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  display: none;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}
#video1 .d-player-wrap,#video2 .d-player-wrap  {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
#iframeContain{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  .containerBg{
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
    top: 0;
    left: 0;
  }
  .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%;
    }
  }
  .topContent {
    width: 100%;
    height: 100px;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 34, 25, 1) 20%,
      rgba(0, 34, 25, 0)
    );
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 20px;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }

  .dh_lb {
    width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
    .left,.right{
      width: 572px;
      height: 100%;
      display: flex;
      flex-direction: column;
       position: absolute;
       top: 0;
       padding-top: 80px;
       box-sizing: border-box;
    }
    .title{
      width: 436px;
      height: 46px;
      background: url("../assets/img/gbzntyj/gaungai/xbt.png") no-repeat;
      font-size: 16px;
      color: #fff;
      text-align: left;
      font-weight: bold;
      line-height: 36px;
      padding-left: 54px;
      padding-top: 7px;
      box-sizing: border-box;
      margin-top: 10px;
      position: relative;
      letter-spacing: 3px;
      .titIcon{
        position: absolute;
        top: 11px;
        left: 13px;
        width: 28px;
        height: 28px;
        animation: titIcon 5s linear infinite;
        // animation-delay: 5s;
        
      }
    }
    .echartBox{
        width: 100%;
        flex: 1;
      }
    .left{
      left: 0;
      padding-left: 34px;
      background:url("../assets/img/gbzntyj/gaungai/zjb.png") no-repeat ;
      .leftBox1{
        width: 100%;
        height: 500px;
        display: flex;
        flex-direction: column;
        .leftBox1Content{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .leftBox1ContentTop{
          width: 100%;
          height: 239px;
          background: url("../assets/img/gbzntyj/gaungai/x.png") no-repeat center center;
          position: relative;
          margin: 30px 0 40px;
          .circle{
            position: absolute;
            top: 50%;
            left: 50%;
            width: 239px;
            height: 239px;
            background: url("../assets/img/gbzntyj/gaungai/nq.png") no-repeat center center;
            margin: -120px 0 0 -120px;
            animation: guangying 2s linear infinite;
          }
          .circleImg{
              position: absolute;
              top: 50%;
              left: 50%;
              z-index: 999;
              width: 36px;
              height: 38px;
              margin: -19px 0 0 -18px;
              animation: left1Img 2s linear infinite;
              
            }
            .leftBox1ContentTopList{
              width: 100%;
              height: 100%;
              position: relative;
              .leftBox1ContentTopItem{
                width: 115px;
                height: 65px;
                background: url("../assets/img/gbzntyj/gaungai/llk.png") no-repeat;
                position: absolute;
                z-index: 999;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                span{
                  display: block;
                  font-size: 14px;
                }
                span.txt1{
                  color: #fff;
                  opacity: .9;
                }
                 span.txt2{
                  color: #00E9EF;
                  font-weight: bold;
                }
              }
              .leftBox1ContentTopItem:nth-child(1){
                top: -8px;
                left: 0;
              }
              .leftBox1ContentTopItem:nth-child(2){
                top: -8px;
                right: 0;
              }
              .leftBox1ContentTopItem:nth-child(3){
                bottom: -8px;
                left: 0;
              }
              .leftBox1ContentTopItem:nth-child(4){
                bottom: -8px;
                right: 0;
              }
            }
        }
        .leftBox1ContentCenter{
          width: 100%;
          height: 46px;
          background: url("../assets/img/gbzntyj/gaungai/rq.png") no-repeat;
          line-height: 46px;
          padding: 0 60px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .dateItem{
            font-size: 18px;
            color: #Fff;
            cursor: pointer;
          }
          .dateItem:hover,.dateItemCur{color: #ffc600;}
        }
        .leftBox1ContentBottom{
          width: 100%;
          flex: 1;
          .leftBox1ContentBottom1{
            display: flex;
            width: 100%;
            height: 100%;
          }
          .leftBox1ContentBottomItem{
            flex: 1;
            display: flex;
            font-size: 14px;
            margin: 20px 0;
            .leftItem{
              background: url("../assets/img/gbzntyj/gaungai/slk.png") no-repeat;
              width: 50px;
              height: 48px;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 25px;
                height: 27px;
                animation: left1Img 1s linear infinite;
              }
            }
            .rightCon{
              display: flex;
              flex-direction: column;
              margin-left: 10px;
              span{
                display: block;
                text-align: left;
              }
              span.txt1{
                color: #00F6F8;
                font-weight: bold;
              }
              span.txt2{
                color: #fff;
              }
            }
          }
        }
        }
        
      }
      .leftBox2{
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
      
    }
    .right{
      right: 0;
      background:url("../assets/img/gbzntyj/gaungai/yjb.png") no-repeat ;
      padding-right: 34px;
      align-items: flex-end;
      .rightBox1{
        height: 630px;
        display: flex;
        flex-direction: column;
        .videoBox{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 10px 20px 0;
          width: 396px;
          .videoBg{
            background: url("../assets/img/gbzntyj/gaungai/spk.png") no-repeat;
            background-size: 100% 100%!important;
            width: 396px;
            height: 228px;
            padding: 5px;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
          }
          .videoTabList{
            display: flex;
            height: 44px;
            justify-content: space-between;
            // margin-top: 10px;
            .videoTabItem{
              width: 80px;
              height: 44px;
              background: url("../assets/img/gbzntyj/gaungai/pg.png") no-repeat;
              font-size: 14px;
              color: #04DFE4;
              text-align: center;
              line-height: 44px;
            }
          }
        }
      }
      .rightBox2{
        flex: 1;
        width: 436px;
        display: flex;
        flex-direction: column;
      }
    }
    



}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  /*引用动画名称*/
  0% {
    transform: scale(1);
  }
50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes left2Img {
  /*引用动画名称*/
  0% {
    margin-top: 0;
  }
50% {
    margin-top: 5px;
  }
  100% {
    margin-top: 0;
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}

.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
